// SPDX-License-Identifier: AGPL-3.0-or-later
import styles from '@app/features/user/components/popouts/UserProfileBadges.module.css';
interface BadgeHoverCardProps { title: string; detail?: string; iconUrl?: string; text?: string; }
export function BadgeHoverCard({title, detail, iconUrl, text}: BadgeHoverCardProps) {
  return <div className={styles.hoverCard} data-flx="user.user-profile-badges.hover-card">
    {iconUrl ? <img src={iconUrl} alt="" aria-hidden="true" className={styles.hoverCardIcon} data-flx="user.user-profile-badges.hover-card-icon" /> : <span className={styles.hoverCardSequence} aria-hidden="true">{text}</span>}
    <strong className={styles.hoverCardTitle} data-flx="user.user-profile-badges.hover-card-title">{title}</strong>
    {detail && detail !== title && <span className={styles.hoverCardDetail} data-flx="user.user-profile-badges.hover-card-detail">{detail}</span>}
  </div>;
}
